{
  "el": {
    "task": {
      "actions": {
        "create": "Εργασία",
        "update": "Επεξεργασία εργασίας"
      },
      "attributes": {
        "assignments_count": "Αναθέσεις",
        "category": "Κατηγορία",
        "created_at": "Δημιουργήθηκε",
        "description": "Περιγραφή",
        "title": "Τίτλος",
        "units": "Ακίνητα"
      },
      "categories": {
        "confirmation": "Επιβεβαίωση",
        "upload": "Ανέβασμα"
      },
      "labels": {
        "no_tasks": "Δεν υπάρχουν ακόμη εργασίες για αυτό το έργο.",
        "required": "Αυτό το πεδίο είναι υποχρεωτικό",
        "units_required": "Επίλεξε τουλάχιστον ένα ακίνητο"
      },
      "toasts": {
        "create": "Η εργασία δημιουργήθηκε",
        "delete": "Η εργασία διαγράφηκε",
        "update": "Η εργασία ενημερώθηκε"
      }
    }
  }
}
